import { Suspense } from 'react';
import PropTypes from 'prop-types';

import FullScreenLoader from './FullScreenLoader';
import ResponsiveHeader from './ResponsiveHeader';

export const PublicLayout = ({ children }) => {
  return (
    <>
      <ResponsiveHeader isPublicScreen />
      <Suspense fallback={<FullScreenLoader />}>{children}</Suspense>
    </>
  );
};

PublicLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
